function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5127",
    transform: "translate(-223 -34)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 131",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(223 34)",
    style: {
      fill: "#4f50d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-facebook-f",
    d: "m7.886 7.055.348-2.27H6.057V3.312a1.135 1.135 0 0 1 1.28-1.226h.99V.153A12.074 12.074 0 0 0 6.569 0 2.771 2.771 0 0 0 3.6 3.055v1.73H1.609v2.27H3.6v5.487h2.457V7.055z",
    transform: "translate(230.39 40)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.99d4bd57966db6147adb37efd8795686.svg";
export { ForwardRef as ReactComponent };